export const MIN_CONSENT_WIDGET = '1';
export const FULL_CONSENT_WIDGET = '2';
